import React from "react";
import { getAvatarUrl } from "./../../../helper/avatarHelper.js";

/**
 * Avatar — componente reutilizavel.
 * Mostra foto custom do user ou gera um DiceBear deterministico.
 *
 * Props:
 *  - user: { id, photo? }
 *  - size: numero em px (default 40)
 *  - style: estilo DiceBear (default 'personas')
 *  - rounded: boolean (default true) - se circular
 *  - border: cor da borda (default '#eee')
 *  - className: classes extras
 */
class Avatar extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errored: false };
  }

  handleError() {
    if (!this.state.errored) this.setState({ errored: true });
  }

  render() {
    var size = this.props.size || 40;
    // Se o user tem avatarStyle salvo (preferencia escolhida no AvatarPicker),
    // usa essa. Senao usa o style passado via prop ou 'personas' default.
    var preferredStyle = (this.props.user && this.props.user.avatarStyle) || null;
    var style = preferredStyle || this.props.style || 'personas';
    var rounded = this.props.rounded !== false;
    var border = this.props.border || '#eee';

    // Se a imagem custom falhou, usa DiceBear como fallback
    var userForUrl = this.state.errored
      ? { id: this.props.user ? this.props.user.id : 'unknown', photo: null }
      : this.props.user;

    var src = getAvatarUrl(userForUrl, style, { size: size * 2 });

    return (
      <img
        src={src}
        alt="avatar"
        className={this.props.className || ''}
        onError={() => this.handleError()}
        style={{
          width: size + 'px',
          height: size + 'px',
          borderRadius: rounded ? '50%' : '8px',
          objectFit: 'cover',
          border: '1px solid ' + border,
          backgroundColor: '#f8f9fa',
          ...(this.props.styleOverride || {})
        }}
      />
    );
  }
}

export default Avatar;
